<template>
  <div class="flex flex-col">
    <SvgIcon class="mx-auto h-16 w-16 text-black xl:h-24 xl:w-24" name="Checkmark-Circle-Thin" />
    <slot></slot>
    <NuxtLink class="btn btn-blue mx-auto mt-20" :to="marketSetup?.startPage ?? ''">
      <CommonLabel path="BWF/shop/checkout/cart/backToShop" />
    </NuxtLink>
  </div>
</template>

<script setup>
import SvgIcon from "~/templates/elements/SvgIcon.vue";
import CommonLabel from "~/templates/components/CommonLabel.vue";

const { marketSetup } = useMarketSetup();

onMounted(() => {
  window.scrollTo(0, 0);
});
</script>
